export const messages = {
  en: {
    serviceBusiness: {
      search: {
        title: 'Search Condition',
        businessTypeCd: 'businessTypeCd',
        invokeType: 'invokeType',
        url: 'url',
        messageTopic: 'messageTopic',
        timeout: 'timeout',
        retryCount: 'retryCount',
        createTime: 'createTime',
        placeholder: 'Please enter serviceBusiness name'
      },
      list: {
        title: 'serviceBusiness List'
      },
      dialog: {
        addTitle: 'Add ServiceBusiness',
        editTitle: 'Edit ServiceBusiness',
        delTitle: 'Delete ServiceBusiness',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      form: {
        businessTypeCd: 'businessTypeCd',
        invokeType: 'invokeType',
        name:'name',
        url: 'url',
        messageTopic: 'messageTopic',
        timeout: 'timeout',
        retryCount: 'retryCount',
        createTime: 'createTime',
      },
      table: {
        businessTypeCd: 'businessTypeCd',
        invokeType: 'invokeType',
        url: 'url',
        messageTopic: 'messageTopic',
        timeout: 'timeout',
        retryCount: 'retryCount',
        createTime: 'createTime',
      },
      validate: {
        invokeType: 'Please enter invokeType',
        timeout: 'Please enter timeout',
        retryCount: 'Please enter retryCount',
        createTime: 'Please enter createTime',
      },
      add: {
        success: 'Add ServiceBusiness success'
      },
      edit: {
        success: 'Edit ServiceBusiness success'
      },
      delete: {
        success: 'Delete ServiceBusiness success',
        confirm: 'Are you sure to delete this serviceBusiness?'
      },
      fetchError: 'Failed to fetch serviceBusiness list'
    }
  },
  zh: {
    serviceBusiness: {
      search: {
        title: '查询条件',
        businessTypeCd: '业务类型',
        invokeType: '调用类型',
        url: '目标地址',
        messageTopic: 'kafka主题',
        timeout: '超时时间',
        retryCount: '重试次数',
        createTime: '创建时间',
        placeholder: '请输入服务实现名称'
      },
      list: {
        title: '服务实现'
      },
      dialog: {
        addTitle: '添加服务实现',
        editTitle: '编辑服务实现',
        delTitle: '删除服务实现',
        cancel: '取消',
        confirm: '确定'
      },
      form: {
        businessTypeCd: '业务类型',
        invokeType: '调用类型',
        name:'业务名称',
        url: '目标地址',
        messageTopic: 'kafka主题',
        timeout: '超时时间',
        retryCount: '重试次数',
        createTime: '创建时间',
      },
      table: {
        businessTypeCd: '业务类型',
        invokeType: '调用类型',
        url: '目标地址',
        messageTopic: 'kafka主题',
        timeout: '超时时间',
        retryCount: '重试次数',
        createTime: '创建时间',
      },
      validate: {
        invokeType: '请输入调用类型',
        timeout: '请输入超时时间',
        retryCount: '请输入重试次数',
        createTime: '请输入创建时间',
      },
      add: {
        success: '添加服务实现成功'
      },
      edit: {
        success: '编辑服务实现成功'
      },
      delete: {
        success: '删除服务实现成功',
        confirm: '确认删除该服务实现吗？'
      },
      fetchError: '获取服务实现列表失败'
    }
  },
  'zh-TW': {
    serviceBusiness: {
      search: {
        title: '查詢條件',
        businessTypeCd: '業務類型',
        invokeType: '調用類型',
        url: '目標地址',
        messageTopic: 'kafka主題',
        timeout: '超時時間',
        retryCount: '重試次數',
        createTime: '創建時間',
        placeholder: '請輸入服務實現名稱'
      },
      list: {
        title: '服務實現'
      },
      dialog: {
        addTitle: '添加服務實現',
        editTitle: '編輯服務實現',
        delTitle: '刪除服務實現',
        cancel: '取消',
        confirm: '確定'
      },
      form: {
        businessTypeCd: '業務類型',
        invokeType: '調用類型',
        name:'業務名稱',
        url: '目標地址',
        messageTopic: 'kafka主題',
        timeout: '超時時間',
        retryCount: '重試次數',
        createTime: '創建時間',
      },
      table: {
        businessTypeCd: '業務類型',
        invokeType: '調用類型',
        url: '目標地址',
        messageTopic: 'kafka主題',
        timeout: '超時時間',
        retryCount: '重試次數',
        createTime: '創建時間',
      },
      validate: {
        invokeType: '請輸入調用類型',
        timeout: '請輸入超時時間',
        retryCount: '請輸入重試次數',
        createTime: '請輸入創建時間',
      },
      add: {
        success: '添加服務實現成功'
      },
      edit: {
        success: '編輯服務實現成功'
      },
      delete: {
        success: '刪除服務實現成功',
        confirm: '確認刪除該服務實現嗎？'
      },
      fetchError: '獲取服務實現列表失敗'
    }
  }
}